import { createContext } from 'react';

import noop from 'helpers/noop';

export interface IModalContextState<P = any> {
  component: React.ComponentType<P> | null;
  props?: P;
}

export interface IModalContext extends IModalContextState {
  showModal: <P extends object>(component: React.ComponentType<P>, props: P) => void;
  hideModal: () => void;
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

const ModalContext = createContext<IModalContext>({
  component: null,
  showModal: noop,
  hideModal: noop,
  open: false,
  handleOpen: noop,
  handleClose: noop,
});

export default ModalContext;
